import { TabsPage } from '@juvare/common-web-ui/TabsPage';
import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import React from 'react';
import { Route, Routes, useNavigate, useParams, useSearchParams } from 'react-router';
import { useDocumentLibraryTranslations } from '../../../../hooks';
import { useManagePermission } from '../../../../hooks/useManagePermission';
import { DocumentLibraryContextProvider } from '../../../../providers';
import { ArchivedFileManager } from '../../ArchivedFileManager';
import { FileManager } from '../../index';
import { FileManagerWrapper } from '../FileManagerWrapper';
import { DocumentPanelHeader } from './components/DocumentPanelHeader';
export const DocumentPanel = (props) => {
    var _a;
    const { t } = useDocumentLibraryTranslations();
    const userState = useUserState();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { showManagePermissionDialog } = useManagePermission();
    const documentPanelTabs = [
        {
            id: 'active',
            label: t('documentPanel.tabs.active'),
            'data-test': 'active-files-tab',
        },
        ...(requireAnySystemPermission(userState, 'manage-documents') || requireAnyOrgPermission(userState, 'manage-documents')
            ? [
                {
                    id: 'archived',
                    label: t('documentPanel.tabs.archived'),
                    'data-test': 'archived-files-tab',
                },
            ]
            : []),
    ];
    const defaultTab = documentPanelTabs[0];
    const activeTab = (_a = documentPanelTabs.find((tab) => tab.id === searchParams.get('tab'))) !== null && _a !== void 0 ? _a : defaultTab;
    React.useEffect(() => {
        if (!searchParams.has('tab')) {
            setSearchParams({ tab: defaultTab.id });
        }
    }, [searchParams, navigate, defaultTab, setSearchParams]);
    const FileManagerComponent = () => {
        const { currentDirectoryId } = useParams();
        return (React.createElement(FileManagerWrapper, null, activeTab.id === 'archived' ? (React.createElement(ArchivedFileManager, { key: currentDirectoryId, currentDirectoryId: currentDirectoryId, navigate: navigate })) : (React.createElement(FileManager, { key: currentDirectoryId, navigate: navigate }))));
    };
    return (React.createElement(DocumentLibraryContextProvider, null,
        React.createElement(TabsPage, { header: React.createElement(DocumentPanelHeader, { activeTabId: activeTab.id, onManagePermissions: showManagePermissionDialog, hideRootHeader: props.hideRootHeader }), tabs: documentPanelTabs, selectedTabId: activeTab.id, onSelectTab: (tab) => {
                const urlParams = new URLSearchParams();
                urlParams.set('tab', tab.id);
                navigate({
                    pathname: '.',
                    search: urlParams.toString(),
                });
            } }, activeTab && (React.createElement(Routes, null,
            React.createElement(Route, { index: true, element: React.createElement(FileManagerComponent, null) }),
            React.createElement(Route, { path: ':currentDirectoryId', element: React.createElement(FileManagerComponent, null) }))))));
};
